export default __webpack_public_path__ + "static/media/mining.278e5524.png";